class AccountsList {
    $onChanges(changesObj) {
        if (changesObj.accounts && this.accounts) {
            this.accounts.forEach(a => {
                a.isPersonal = a.subtype === 'Person';
                a.isCommercial = a.subtype === 'Company';
            });
        }
    }
}

export default AccountsList;

